import clsx from 'clsx'
import { useRouter } from 'next/router'
import { useRef, type FunctionComponent } from 'react'
import { useClickAway } from 'react-use'
import { menuItems } from '../../const/MenuItems'
import { useTranslate } from '../../contexts/TranslationContext'
import SvgCross from '../../svg/icons/Cross'
import { Button } from './Button'
import { Logo } from './Logo'
import style from './MobileMenu.module.sass'
import { Modal } from './Modal'

export type MobileMenuProps = {
	close: () => void
	isOpen?: boolean
}

export const MobileMenu: FunctionComponent<MobileMenuProps> = ({ close, isOpen = false }) => {
	const ref = useRef(null)

	useClickAway(ref, () => {
		close()
	})

	const translate = useTranslate()
	const router = useRouter()

	return (
		<Modal close={close} type="menu" isOpen={isOpen}>
			<div className={style.wrapper} ref={ref}>
				<div className={style.header}>
					<div className={style.logoWrapper}>
						<Logo />
					</div>
					<div className={style.closeWrapper}>
						<Button
							label={<SvgCross />}
							ariaLabel={translate('header.menu.close.button')}
							icon={{ aloneStanding: true }}
							type={{ variant: 'transparent' }}
							onClick={close}
							hoverBackground
						/>
					</div>
				</div>
				<ul className={style.menu}>
					{menuItems.map(
						(item) =>
							item.link && (
								<div className={style.itemWrapper} key={item.link}>
									<a
										href={item.link}
										title={item.name}
										className={router.pathname === item.link ? style.itemIsActive : ''}
									>
										<li className={clsx(style.item, router.pathname === item.link && style.itemIsActive)}>
											{item.label}
										</li>
									</a>
								</div>
							),
					)}
				</ul>
			</div>
		</Modal>
	)
}
